import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../../types";

export default function AiIdeaFeedbackContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey={
        status === "success"
          ? "notifications.aiIdeaFeedbackSuccess"
          : status === "pending"
            ? "notifications.aiIdeaFeedback"
            : "notifications.aiIdeaFeedbackFailed"
      }
      values={{ idea: ownerIdea?.name || "Deleted" }}
    />
  );
}
